import axios from "axios";
import { baseUrl } from "../utils/constants";

export const updateContractorApi = async (userToken, params) => {
    return new Promise(async (resolve, reject) => {
        const url = `${baseUrl}/contractor/update-profile`
        try {
            let response = await axios({
                method: "POST",
                headers: {
                    Authorization: userToken,
                    "Content-Type": "application/x-www-form-urlencoded",
                },
                url: url,
                data: params
            })
            resolve(response.data.data)
        } catch (error) {
            console.log("api error::", error.response?.data);
            reject(error.response?.data)
        }
    })
}

export const updateContractorNotificationSettings = async (userToken, params) => {
    return new Promise(async (resolve, reject) => {
        const url = `${baseUrl}/contractor/update-notification-setting`
        try {
            let response = await axios({
                method: "POST",
                headers: {
                    Authorization: userToken,
                    'Content-Type': 'multipart/form-data'
                },
                url: url,
                data: params
            })
            resolve(response.data.data)
        } catch (error) {
            console.log("api error::", error.response?.data);
            reject(error.response?.data)
        }
    })
}

export const fatchContractorProfileApi = async (userToken) => {
    return new Promise(async (resolve, reject) => {
        const url = `${baseUrl}/contractor/get-profile`
        try {
            let response = await axios({
                method: "GET",
                headers: {
                    Authorization: userToken,
                    'Content-Type': 'multipart/form-data'
                },
                url: url
            })

            resolve(response.data.data)
        } catch (error) {
            console.log("api error::", error.response?.data);
            reject(error.response?.data)
        }
    })
}

